import { AnimatePresence, motion, Variants } from 'motion/react';
import { useSelector } from 'react-redux';
import { cn } from '../../../../utils/cn';
import { usePermissions } from '../../hooks/use-permissions.ts';
import { getSelectedSiteId } from '../../store/siteInfoSlice.ts';
import { getBrowseMode } from '../../store/uiSlice';
import { Collaboration } from './collaboration.tsx';
import { Mode } from './mode.tsx';
import { PageControls } from './page-controls.tsx';

interface BottomBarProps {
  constraintsRef: React.RefObject<HTMLDivElement | null>;
}

const bottomBarVariants: Variants = {
  open: {
    opacity: 1,
    x: '-50%',
    y: 0,
    left: '50%',
    bottom: 10,
    transition: { duration: 0.5 },
  },
  closed: {
    opacity: 0,
    x: '-50%',
    y: 100,
    left: '50%',
    bottom: 10,
    transition: { duration: 0.5 },
  },
};

export const BottomBar = ({ constraintsRef }: BottomBarProps) => {
  const browseMode = useSelector(getBrowseMode);
  const siteId = useSelector(getSelectedSiteId);

  const { isPermitted } = usePermissions();


  return (
    <>
      <AnimatePresence>
        <motion.div
          drag="y"
          dragElastic={0.1}
          dragMomentum={false}
          dragConstraints={constraintsRef}
          transformTemplate={({ x, y }) => `translateX(${x}) translateY(${y})`}
          initial="closed"
          animate="open"
          exit="closed"
          variants={bottomBarVariants}
          style={{
            boxShadow: '0 0 0 1px color-mix(in oklab, #0000330f, #f0f0f3 25%), 0 12px 60px #00000026, 0 16px 64px #00005506, 0 16px 36px -20px #00062e12',
          }}
          className={cn(
            'fixed pointer-events-auto grid grid-cols-3 rounded-2xl px-2 h-[56px] gap-2 md:gap-0 w-[96vw] md:w-full transition-[max-width] delay-500',
            'md:grid-cols-[2fr_1fr_2fr]',
            browseMode ? 'md:max-w-[450px]' : 'md:max-w-[1000px]'
          )}
        >
          <div
            className='absolute bg-card brightness-110 dark:brightness-100 saturate-50 dark:saturate-100 dark:bg-opacity-100 bg-opacity-90 backdrop-blur-lg h-full w-full z-[-2] left-0 top-0 rounded-2xl'></div>

          <PageControls siteId={siteId} />
          {isPermitted("collaborate-bottom-bar-browse-comment") && <Mode />}
          <Collaboration />
        </motion.div>
      </AnimatePresence>
    </>
  );
};